// client/src/socket.js
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// ===== ИГРА (как у тебя было) =====
const REJOIN_EVENT = 'joinTable';
const RESYNC_EVENT = 'backgammontFetchData'; // оставляю как у тебя

// ===== ПОДДЕРЖКА (НОВОЕ) =====
const SUPPORT_ADMIN_JOIN_EVENT = 'support:admin-join';
const SUPPORT_ADMIN_LEAVE_EVENT = 'support:admin-leave'; // можно не использовать, но пусть будет
const SUPPORT_NOTIFY_EVENT = 'support:notify';

const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ['websocket'],
  reconnection: true,
  closeOnBeforeunload: false,
  pingTimeout: 20000,
  pingInterval: 25000,
});

// ------------------------------------------------------------
// Память последнего стола (чтобы при реконнекте знать куда вернуться)
let _lastTableId = null;

export function setCurrentTableId(tableId) {
  const id = Number(tableId);
  if (Number.isFinite(id) && id > 0) {
    _lastTableId = id;
    try { localStorage.setItem('currentTableId', String(id)); } catch {}
  }
}

function getRememberedTableId() {
  if (Number.isFinite(_lastTableId)) return _lastTableId;
  try {
    const raw = Number(localStorage.getItem('currentTableId'));
    if (Number.isFinite(raw) && raw > 0) {
      _lastTableId = raw;
      return raw;
    }
  } catch {}
  return null;
}

// ------------------------------------------------------------
// Авторизация + connect (общая для игры и поддержки)
export function ensureSocketAuthAndConnect() {
  try {
    const token = localStorage.getItem('token');
    if (token) socket.auth = { token };
  } catch {}

  if (!socket.connected && !socket.connecting) socket.connect();
}

// ------------------------------------------------------------
// ИГРА: re-join и re-sync
export function rejoinAndResync(tableIdLike) {
  const id = Number(tableIdLike ?? getRememberedTableId());
  if (!Number.isFinite(id) || id <= 0) return;

  // joinTable у тебя объект
  socket.emit(REJOIN_EVENT, { tableId: id });
  // backgammontFetchData у тебя число
  socket.emit(RESYNC_EVENT, id);
}

// ------------------------------------------------------------
// ПОДДЕРЖКА: Вступить/выйти из комнаты админов
export function joinSupportAdminsRoom() {
  ensureSocketAuthAndConnect();
  socket.emit(SUPPORT_ADMIN_JOIN_EVENT);
}

export function leaveSupportAdminsRoom() {
  // connect не обязателен, но если сокет не подключен — emit не улетит
  if (socket.connected) socket.emit(SUPPORT_ADMIN_LEAVE_EVENT);
}

// Подписка на уведомления поддержки
export function onSupportNotify(handler) {
  socket.on(SUPPORT_NOTIFY_EVENT, handler);
  return () => socket.off(SUPPORT_NOTIFY_EVENT, handler);
}

// ------------------------------------------------------------
// Логи (можешь оставить)
socket.on('connect', () => {
  console.log('[WS] connect', socket.id);

  // если есть стол — восстановим
  rejoinAndResync();
});







socket.on('short_forceActiveCashTable', (payload) => {
  const activeTableId =
    Number(payload?.activeTableId);

  const activeType =
    payload?.activeType === 'long'
      ? 'long'
      : 'short';

  if (
    !Number.isInteger(activeTableId) ||
    activeTableId <= 0
  ) {
    console.warn(
      '[CASH] неверный activeTableId:',
      payload
    );

    return;
  }

  console.warn(
    '[CASH] возврат в активный стол:',
    payload
  );

  /*
   * Активный стол — длинный.
   */
  if (activeType === 'long') {
    /*
     * Не позволяем short-сокету после реконнекта
     * снова отправить joinTable в старый короткий стол.
     */
    _lastTableId = null;

    try {
      localStorage.removeItem('currentTableId');
      localStorage.setItem('gameType', 'long');
    } catch (e) {}

    const targetPath =
      `/longGame/${activeTableId}`;

    if (window.location.pathname !== targetPath) {
      window.location.replace(targetPath);
    }

    return;
  }

  /*
   * Активный стол — короткий.
   */
  setCurrentTableId(activeTableId);

  try {
    localStorage.setItem('gameType', 'short');
  } catch (e) {}

  const targetPath =
    `/ShortBackgammonBoard/${activeTableId}`;

  if (window.location.pathname === targetPath) {
    rejoinAndResync(activeTableId);
    return;
  }

  window.location.replace(targetPath);
});
/*
 * Сервер обнаружил попытку войти во второй короткий cash-стол.
 * Жёстко возвращаем пользователя в уже существующую игру.
 */
// socket.on('short_forceActiveCashTable', (payload) => {
//   const activeTableId =
//     Number(payload?.activeTableId);

//   if (
//     !Number.isFinite(activeTableId) ||
//     activeTableId <= 0
//   ) {
//     console.warn(
//       '[SHORT] неверный activeTableId:',
//       payload
//     );
//     return;
//   }

//   console.warn(
//     '[SHORT] возврат в активный cash-стол:',
//     payload
//   );

//   setCurrentTableId(activeTableId);

//   try {
//     localStorage.setItem('gameType', 'short');
//   } catch (e) {}

//   const targetPath =
//     `/ShortBackgammonBoard/${activeTableId}`;

//   /*
//    * Если мы уже на правильном столе —
//    * просто повторно синхронизируем состояние.
//    */
//   if (window.location.pathname === targetPath) {
//     rejoinAndResync(activeTableId);
//     return;
//   }

//   /*
//    * replace нужен, чтобы кнопка "Назад"
//    * не возвращала пользователя на запрещённый стол.
//    */
//   window.location.replace(targetPath);
// });

socket.on('forceLogout', (payload) => {
// socket.on('connect', () => {
//   console.log('[WS] connect', socket.id);

//   // если есть стол — восстановим
//   rejoinAndResync();
// });

// socket.on('forceLogout', (payload) => {
  console.log('[WS] forceLogout', payload);
  try { socket.disconnect(); } catch (e) {}
  // важно: localStorage можно не трогать, как ты и хотел
  window.location.replace('/login');
});


socket.on('disconnect', (reason) => console.log('[WS] disconnect', reason));
socket.on('connect_error', (e) => console.log('[WS] connect_error', e?.message || e));
socket.on('error', (e) => console.log('[WS] error', e));

socket.io.on('reconnect_attempt', (n) => console.log('[WS] reconnect_attempt', n));
socket.io.on('reconnect', (n) => {
  console.log('[WS] reconnect', n);
  rejoinAndResync();
});




export default socket;














// // client/src/socket.js
// import { io } from 'socket.io-client';

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// /** ← ПОПРАВЬ, если на сервере другие названия */
// const REJOIN_EVENT = 'joinTable';
// // На сервере у тебя по логу встречалось "backgammontFetchData" (с буквой t).
// // Если именно так — оставь точно так же:
// const RESYNC_EVENT = 'backgammontFetchData';
// // Если у тебя на сервере "backgammonFetchData" без t — просто поменяй строку выше.

// const socket = io(SOCKET_URL, {
//   autoConnect: false,
//   transports: ['websocket'],
//   reconnection: true,
//   closeOnBeforeunload: false,
//   pingTimeout: 20000,
//   pingInterval: 25000,
// });

// // ———————————————————————————————————————————————
// // Память последнего стола (чтобы при реконнекте знать куда вернуться)
// let _lastTableId = null;

// /** ВЫЗЫВАЙ ЭТО при заходе на стол (например, в BoardDisplay при монтировании) */
// export function setCurrentTableId(tableId) {
//   const id = Number(tableId);
//   if (Number.isFinite(id) && id > 0) {
//     _lastTableId = id;
//     try { localStorage.setItem('currentTableId', String(id)); } catch {}
//   }
// }

// /** Если надо — подтяни id из LS (fallback) */
// function getRememberedTableId() {
//   if (Number.isFinite(_lastTableId)) return _lastTableId;
//   try {
//     const raw = Number(localStorage.getItem('currentTableId'));
//     if (Number.isFinite(raw) && raw > 0) {
//       _lastTableId = raw;
//       return raw;
//     }
//   } catch {}
//   return null;
// }

// /** Выставляем токен и коннектимся только когда надо */
// export function ensureSocketAuthAndConnect() {
//   try {
//     const token = localStorage.getItem('token');
//     if (token) socket.auth = { token };
//   } catch {}
//   if (!socket.connected && !socket.connecting) socket.connect();
// }

// /** Ре-join и ре-синхронизация. ВАЖНО: отправляем ЧИСЛО, не объект */
// export function rejoinAndResync(tableIdLike) {
//   const id = Number(tableIdLike ?? getRememberedTableId());
//   if (!Number.isFinite(id) || id <= 0) return;

// socket.emit(REJOIN_EVENT, { tableId: id }); // ← ОБЪЕКТ
// socket.emit(RESYNC_EVENT, id);              // ← ЧИСЛО (как любит сервер)

// }

// /** Логи (можно оставить/удалить) */
// socket.on('connect', () => {
//   console.log('[WS] connect', socket.id);
//   rejoinAndResync();
// });
// socket.on('disconnect', (reason) => console.log('[WS] disconnect', reason));
// socket.on('connect_error', (e) => console.log('[WS] connect_error', e?.message || e));
// socket.on('error', (e) => console.log('[WS] error', e));

// socket.io.on('reconnect_attempt', (n) => console.log('[WS] reconnect_attempt', n));
// socket.io.on('reconnect', (n) => {
//   console.log('[WS] reconnect', n);
//   rejoinAndResync();
// });

// export default socket;



// import { io } from 'socket.io-client';

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// const socket = io(SOCKET_URL, {
//   autoConnect: false,
//   transports: ['websocket'],       // можно временно убрать для теста
//   reconnection: true,
//   closeOnBeforeunload: false,
//   pingTimeout: 20000,
//   pingInterval: 25000,
// });

// /* ⬇️ ДОБАВЬ ЭТО СРАЗУ ПОСЛЕ создании socket */
// export function ensureSocketAuthAndConnect() {
//   try {
//     const token = localStorage.getItem('token');
//     if (token) socket.auth = { token };
//   } catch {}
//   if (!socket.connected && !socket.connecting) socket.connect();
// }
// /* ⬆️ ДОБАВЛЕНО */
 
// socket.on('connect', () => console.log('[WS] connect', socket.id));
// socket.on('disconnect', (reason) => console.log('[WS] disconnect', reason));
// socket.on('error', (e) => console.log('[WS] error', e));
// socket.io.on('reconnect_attempt', (n) => console.log('[WS] reconnect_attempt', n));
// socket.io.on('reconnect', (n) => console.log('[WS] reconnect', n));

// export default socket;



// const socket = io(`http://${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_PORT}`, {
//   autoConnect: false, // Сокет не будет автоматически подключаться
// });

// export default socket;

// socket.js
// import { io } from 'socket.io-client';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const socket = io(API_URL, {
//   autoConnect: false,
//   transports: ['websocket'],
//   reconnection: true,
//   reconnectionAttempts: Infinity,
//   reconnectionDelay: 500,
//   reconnectionDelayMax: 4000,
//   closeOnBeforeunload: false,
//   pingTimeout: 20000,
//   pingInterval: 25000,
// });

// socket.on('connect',   () => console.log('[WS] connect', socket.id));
// socket.on('disconnect',(r) => console.log('[WS] disconnect', r));
// socket.on('error',     (e) => console.log('[WS] error', e));
// socket.io.on('reconnect_attempt', (n) => console.log('[WS] reconnect_attempt', n));
// socket.io.on('reconnect',         (n) => console.log('[WS] reconnect', n));
// socket.io.on('ping', () => console.log('[WS] ping'));
// socket.io.on('pong', (ms) => console.log('[WS] pong', ms));

// export default socket;


// // socket.js
// import { io } from 'socket.io-client';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const socket = io(API_URL, {
//   autoConnect: false,
//   transports: ['websocket'],
//   reconnection: true,
//   // ВАЖНО: не рвём сокет при beforeunload — пусть доживёт, пока отправляем beacon
//   closeOnBeforeunload: false,
//   // (опционально) более терпимый таймаут пинга, чтобы не «флапал»
//   pingTimeout: 20000,
//   pingInterval: 25000,
// });

// socket.on('connect', () => console.log('[WS] connect', socket.id));
// socket.on('disconnect', (reason) => console.log('[WS] disconnect', reason));
// socket.on('error', (e) => console.log('[WS] error', e));
// socket.io.on('reconnect_attempt', (n) => console.log('[WS] reconnect_attempt', n));
// socket.io.on('reconnect', (n) => console.log('[WS] reconnect', n));
// socket.io.on('ping', () => console.log('[WS] ping'));
// socket.io.on('pong', (ms) => console.log('[WS] pong', ms));


// export default socket;



// socket.js
// import { io } from 'socket.io-client';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const socket = io(API_URL, {
//   autoConnect: false,
//   transports: ['websocket'],   // ← ОБЯЗАТЕЛЬНО
//   withCredentials: false,
// });

// export default socket;




// рабочий для клиента
// import { io } from 'socket.io-client';

// // const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = process.env.REACT_APP_API_URL;
// const PORT = process.env.REACT_APP_PORT;
// console.log('234244',API_URL,PORT);

// const socket = io(`http://${API_URL}:${PORT}`, {
//   autoConnect: false,
// });

// export default socket;
